/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section5_TitleInputs */

const en_about_section5_title = /** @type {(inputs: About_Section5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Source`)
};

const ko_about_section5_title = /** @type {(inputs: About_Section5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오픈 소스`)
};

const ja_about_section5_title = /** @type {(inputs: About_Section5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オープンソース`)
};

/**
* | output |
* | --- |
* | "Open Source" |
*
* @param {About_Section5_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section5_title = /** @type {((inputs?: About_Section5_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section5_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section5_title(inputs)
	if (locale === "ko") return ko_about_section5_title(inputs)
	return ja_about_section5_title(inputs)
});